module.exports = __webpack_public_path__ + "img/4F251B_381710_43241B_602F23-256px.2d932976.png";